var getBaseURL = require('lib/util').getBaseURL;

function getDocumentBaseURL() {
    return getBaseURL(require('app').getDocumentURL());
}

function wrapStringArray(data, size) {
    var strings = new Array(size);
    for (var i = 0, p = data >>> 2; i < size; ++i, ++p)
        strings[i] = UTF8ToString(HEAPU32[p]);
    return strings;
}

function wrapSheetArray(data, size) {
    if (!size) return [];

    var sheets = new Array(size);
    for (var i = 0, p = data >>> 2; i < size; ++i, p += 3) {
        sheets[i] = {
            id: UTF8ToString(HEAPU32[p]),
            description: UTF8ToString(HEAPU32[p + 1]),
            indentationLevel: HEAP32[p + 2]
        };
    }
    return sheets;
}

function unmarshalIndexArray(indexArray) {
    var itemCount = getValue(indexArray, 'i32'),
        i,
        res = new Array(itemCount);
    for (i = 1; i <= itemCount; ++i) {
        res[i - 1] = getValue(indexArray + i * 4, 'i32');
    }
    return res;
}

function unmarshalObjectArray(handles) {
    if (!handles)
        return [];
    var p, handle, objects = [];
    for (p = handles >>> 2; (handle = HEAPU32[p]); ++p)
        objects.push(handle);
    return objects;
}

function unmarshalFloatArray(floats, count) {
    if (!floats) return null;
    var p = floats >>> 2;
    switch (count) {
        case 0: return null;
        case 1: return HEAPF32[p];
        case 2: return [HEAPF32[p], HEAPF32[p + 1]];
        case 3: return [HEAPF32[p], HEAPF32[p + 1], HEAPF32[p + 2]];
        case 4: return [HEAPF32[p], HEAPF32[p + 1], HEAPF32[p + 2], HEAPF32[p + 3]];
        default:
            var a = new Array(count);
            for (var i = 0; i < count; i++) {
                a[i] = HEAPF32[p + i];
            }
            return a;
    }
}

function assignVec3f(p, value) {
    var q = p >>> 2;
    HEAPF32[q] = value[0];
    HEAPF32[q + 1] = value[1];
    HEAPF32[q + 2] = value[2];
    return p;
}

function assignRotation(p, value) {
    var q = p >>> 2;
    HEAPF32[q] = value[0];
    HEAPF32[q + 1] = value[1];
    HEAPF32[q + 2] = value[2];
    HEAPF32[q + 3] = value[3];
    return p;
}

function toVec3f(array) {
    return (array && array.length > 2) ? assignVec3f(stackAlloc(12), array) : null;
}

function toRotation(array) {
    return (array && array.length > 2) ? assignRotation(stackAlloc(16), array) : null;
}

function createNavigationCubeCanvas(titles, style, sideOrientations) {
    var scale = window.devicePixelRatio,
        size = 256 * scale,
        s0 = 48 * scale,
        s1 = size - 2 * s0,
        l = 3 * scale,
        es0 = s0 - 2 * l,
        es1 = s1 - 2 * l;

    var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        i, x, y;

    canvas.width = 4 * size;
    canvas.height = 4 * size;

    ctx.fillStyle = style.border;
    ctx.fillRect(0, 0, 2 * size, 3 * size);
    ctx.fillStyle = style.hoveredBorder;
    ctx.fillRect(2 * size, 0, 2 * size, 3 * size);

    for (i = 0; i < 6; ++i) {
        x = l + (i % 2) * size,
            y = l + (i >> 1) * size;

        ctx.fillStyle = style.background;
        ctx.fillRect(x, y, size - 2 * l, size - 2 * l);

        x += 2 * size;
        ctx.fillStyle = style.hoveredBackground;
        ctx.fillRect(x, y, es0, es0);
        ctx.fillRect(x + s0, y, es1, es0);
        ctx.fillRect(x + s0 + s1, y, es0, es0);
        y += s0;
        ctx.fillRect(x, y, es0, es1);
        ctx.fillRect(x + s0, y, es1, es1);
        ctx.fillRect(x + s0 + s1, y, es0, es1);
        y += s1;
        ctx.fillRect(x, y, es0, es0);
        ctx.fillRect(x + s0, y, es1, es0);
        ctx.fillRect(x + s0 + s1, y, es0, es0);
    }

    ctx.fillStyle = style.textColor;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = '' + Math.round(size * 0.20) + 'px sans-serif';

    var maxWidth = 0;
    titles.forEach(function (title) {
        maxWidth = Math.max(maxWidth, ctx.measureText(title).width);
    });
    if (maxWidth > s1 + s0) {
        ctx.font = '' + Math.round(size * 0.20 * (s1 + s0) / maxWidth) + 'px sans-serif';
    }

    function drawText(text, x, y, orientation) {
        if (!orientation) {
            ctx.fillText(text, x, y);
        } else {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(-orientation * Math.PI / 2);
            ctx.fillText(text, 0, 0);
            ctx.restore();
        }
    }

    for (i = 0; i < Math.min(6, titles.length); ++i) {
        x = ((i % 2) + 0.5) * size,
            y = (2 - (i >> 1) + 0.5) * size;
        drawText(titles[i], x, y, sideOrientations[i]);
        drawText(titles[i], x + 2 * size, y, sideOrientations[i]);
    }
    return canvas;
}

function getCanvasTopLeft() {
    var box = Module.canvas.getBoundingClientRect(),
        x = box.left;
    y = box.top;
    container = Array.from(parent.document.querySelectorAll('iframe')).find(function (i) { return i.contentDocument === document; });
    if (container) {
        box = container.getBoundingClientRect();
        x += Math.round(box.left + container.clientLeft);
        y += Math.round(box.top + container.clientLeft);
    }
    return { x: x, y: y };
}
function dispatchMouseEvent(e) {
    var sp = stackSave(),
        eventStruct = stackAlloc(68),
        p = eventStruct >>> 2,
        offset = getCanvasTopLeft(),
        handler = e.type === 'mouseup' ? Module._tiramisu_mouseUp : Module._tiramisu_mouseDragged,
        container = Array.from(parent.document.querySelectorAll('iframe')).find(function (i) { return i.contentDocument === e.view.document; });
    if (container) {
        var box = container.getBoundingClientRect();
        offset.x -= Math.round(box.left + container.clientLeft),
            offset.y -= Math.round(box.top + container.clientTop);
    }
    setValue(eventStruct, e.timeStamp, 'double');
    HEAP32[p + 2] = e.screenX;
    HEAP32[p + 3] = e.screenY;
    HEAP32[p + 4] = e.clientX;
    HEAP32[p + 5] = e.clientY;
    HEAP32[p + 6] = e.ctrlKey;
    HEAP32[p + 7] = e.shiftKey;
    HEAP32[p + 8] = e.altKey;
    HEAP32[p + 9] = e.metaKey;
    HEAP16[p * 2 + 20] = e.button;
    HEAP16[p * 2 + 21] = e.buttons;
    HEAP32[p + 11] = e.movementX;
    HEAP32[p + 12] = e.movementY;
    HEAP32[p + 13] = e.clientX - offset.x;
    HEAP32[p + 14] = e.clientY - offset.y;
    handler(eventStruct);
    stackRestore(sp);
}

function getCameraOrientation(orientation) {
    var o;

    if (!Array.isArray(orientation)) {
        o = {
            "front": [0, 1, 0, Math.PI],
            "back": [0, 1, 0, 0],
            "left": [0, -1, 0, Math.PI / 2],
            "right": [0, 1, 0, Math.PI / 2],
            "top": [1, 0, 0, -Math.PI / 2],
            "bottom": [0, 0.707107, -0.707107, Math.PI],
            "isometric": [-.156558, -.912487, -337964, 2.41886]
        }[orientation];
    } else if (orientation.length === 4) {
        o = orientation;
    }
    return o;
}

function getCanvasWithImageData(data) {
    if (!data)
        return null;

    var width = HEAP32[data >>> 2],
        height = HEAP32[(data >>> 2) + 1],
        canvas = document.createElement('canvas'),
        context = canvas.getContext('2d'),
        imageData = context.createImageData(width, height);

    imageData.data.set(HEAPU8.subarray(data + 8, data + 8 + width * height * 4));
    canvas.width = width;
    canvas.height = height;
    context.putImageData(imageData, 0, 0);
    return canvas;
}


function unmarshalPickResult(result) {
    // Fields of the result structure
    //     Vec3f coord;
    //     Vec3f normal;
    //     Vec3f sceneCoord;
    //     Vec3f sceneNormal;
    //     Node* chain[];
    var p = result >>> 2;
    return {
        coord: [HEAPF32[p], HEAPF32[p + 1], HEAPF32[p + 2]],
        normal: [HEAPF32[p + 3], HEAPF32[p + 4], HEAPF32[p + 5]],
        sceneCoord: [HEAPF32[p + 6], HEAPF32[p + 7], HEAPF32[p + 8]],
        sceneNormal: [HEAPF32[p + 9], HEAPF32[p + 10], HEAPF32[p + 11]],
        chain: unmarshalObjectArray(result + 48)
    };
}

function unmarshalPickResults(results) {
    var count = HEAPU32[results >>> 2];
    var result = results + 4,
        objs = [],
        obj, i;
    for (i = 0; i < count; ++i) {
        obj = unmarshalPickResult(result);
        objs.push(obj);
        result += 52 + obj.chain.length * 4;
    }
    return objs;
}

/**
 * (description)
 * 
 * @private
 * @param {Handle[]|Handle|Object} handles - an array of 3D object handles
 * @param {function} lambda - function (objects, count) {}
 */
function withObjectHandles(handles, lambda) {
    var sp = stackSave();
    var count = 0,
        objects = 0;
    if (handles) {
        if (!Array.isArray(handles))
            handles = [handles];
        count = handles.length;
        objects = stackAlloc(count * 4);
        for (var i = 0, p = objects >>> 2; i < count; ++i, ++p) {
            var h = handles[i];
            HEAP32[p] = typeof h === "object" ? h.handle : h;
        }
    }
    lambda(objects, count);
    stackRestore(sp);
}

function createURLFromDataAndReleaseChunk(chunk, options) {
    if (chunk == 0)
        return;

    var size = HEAPU32[chunk >>> 2],
        dataStart = HEAPU32[(chunk >>> 2) + 1],
        data = HEAPU8.subarray(dataStart, dataStart + size),
        DOMURL = window.URL || window.webkitURL || window,
        url = DOMURL.createObjectURL(new Blob([data], options || {}));

    Module._free(chunk);
    return url;
}

function revokeDataURL(url) {
    var DOMURL = window.URL || window.webkitURL || window;
    DOMURL.revokeObjectURL(url);
}

function createImageFromData(chunk, image, options, autoRevokeTimeout) {
    var url = createURLFromDataAndReleaseChunk(chunk, options);

    if (!url) return;

    if (typeof autoRevokeTimeout === 'undefined') {
        autoRevokeTimeout = !image ? -1 : 0;
    }

    if (!image) {
        image = new Image();
    }

    if (autoRevokeTimeout >= 0) {
        function completeHandler() {
            if (!autoRevokeTimeout) {
                revokeDataURL(url);
            } else {
                setTimeout(function () {
                    try {
                        revokeDataURL(url);
                    } catch (e) { }
                }, autoRevokeTimeout);
            }
            image.removeEventListener('load', completeHandler);
            image.removeEventListener('error', completeHandler);
        }
        image.addEventListener('load', completeHandler);
        image.addEventListener('error', completeHandler);
    }

    image.src = url;
    return image;
}

function marshallTypedArray(typedArray) {
    var dataSize = typedArray.BYTES_PER_ELEMENT * typedArray.length,
        dataOffset = _malloc(dataSize),
        result = new Uint8Array(Module.HEAPU8.buffer, dataOffset, dataSize);
    result.set(new Uint8Array(typedArray.buffer));
    return result;
}

module.exports = {
    createURLFromDataAndReleaseChunk: createURLFromDataAndReleaseChunk,
    revokeDataURL: revokeDataURL,
    createImageFromData: createImageFromData,
    withObjectHandles: withObjectHandles,
    marshallTypedArray: marshallTypedArray,
    unmarshalIndexArray: unmarshalIndexArray,
    unmarshalPickResult: unmarshalPickResult,
    unmarshalPickResults: unmarshalPickResults,
    unmarshalObjectArray: unmarshalObjectArray,
    unmarshalFloatArray: unmarshalFloatArray,
    getCanvasWithImageData: getCanvasWithImageData,
    getCameraOrientation: getCameraOrientation,
    getCanvasTopLeft: getCanvasTopLeft,
    dispatchMouseEvent: dispatchMouseEvent,
    createNavigationCubeCanvas: createNavigationCubeCanvas,
    assignVec3f: assignVec3f,
    toVec3f: toVec3f,
    assignRotation: assignRotation,
    toRotation: toRotation,
    wrapStringArray: wrapStringArray,
    wrapSheetArray: wrapSheetArray,
    getDocumentBaseURL: getDocumentBaseURL,
    getBaseURL: getBaseURL
};